export const environment = {
  production: true,
	domain :'http://localhost:4200',
	// consumerDomain: 'https://zeamed.com',
	consumerDomain: 'https://qa.zeamed.com',
	
	providerDomain: 'https://cdn.zeatool.com',

	// consumerDomain: 'http://3.214.75.81:8000',
	// providerDomain: 'http://3.214.75.81:8000',
	//  superAdminDomain: 'https://test-api.zeamed.com:8000',
	// superAdminDomain: 'http://localhost:3000/dev',
	zeatool_be:'https://api.zeatool.com:1001',
	superAdminDomain: 'https://cvz40hp506.execute-api.us-east-1.amazonaws.com/dev',
	superAdminDomain1: 'https://73vzn970nc.execute-api.us-east-1.amazonaws.com/dev',

	stripe: {
		publishableKey: 'pk_test_7kXPoSMwRiAzaHt8idPMkupG'
	},
	contactUs_usa: '+1313671-1935',
	providerTypes: [
		// { name: 'Acute Care Hospitals', value: 0 },
		// { name: 'Imaging Center', value: 1 },
		// { name: 'Ambulatory Services', value: 2 },
		// { name: 'Doctors Office', value: 3 },
		// { name: 'Urgent Care', value: 4 },
		// { name: 'Surgery Center', value: 5 },
		{ name: 'Acute Care Hospitals', value: 0 },
		{ name: 'Long Term Acute Care Hospitals', value: 7 },
		{ name: 'Inpatient Rehabilitation Hospitals', value: 8 },
		{ name: 'Critical Access Hospitals', value: 6 },
		{ name: 'Childrens', value: 9 },
		{ name: 'Psychiatric', value: 10 },
	],
	paymentModes: [
		{ name: 'Card', value: 0 },
		{ name: 'Cash', value: 1 },
		{ name: 'ZeaCredits', value: 2 },
		{ name: 'ZeaCredits + Card', value: 3 },
		{ name: 'ZeaCredits + Cash', value: 4 },
		{ name: 'ZeaCard', value: 5 },

	],
	codeTypesList: [
		{ name: 'HCPCS', value: 0 },
		{ name: 'CPT', value: 1 },
		{ name:'APC', value: 2 },
		{ name: 'APR-DRG', value: 3 },
		{ name: 'DRG', value: 4 },
		{ name: 'NDC', value: 5 },
		{ name: 'Other', value: 6 },
	],
	colors: {
		customPrimary: '#20b04b',
		customDanger: '#ea1d25',
		customInfo: '#68b3cd',
	},
  	zeacardStates: [
		{ name: "Alabama", abbreviation: "AL" },
		{ name: "Alaska", abbreviation: "AK" },
		{ name: "Arizona", abbreviation: "AZ" },
		{ name: "Arkansas", abbreviation: "AR" },
		{ name: "California", abbreviation: "CA" },
		{ name: "Colorado", abbreviation: "CO" },
		{ name: "Connecticut", abbreviation: "CT" },
		{ name: "Delaware", abbreviation: "DE" },
		{ name: "Florida", abbreviation: "FL" },
		{ name: "Georgia", abbreviation: "GA" },
		{ name: "Hawaii", abbreviation: "HI" },
		{ name: "Idaho", abbreviation: "ID" },
		{ name: "Illinois", abbreviation: "IL" },
		{ name: "Indiana", abbreviation: "IN" },
		{ name: "Iowa", abbreviation: "IA" },
		{ name: "Kansas", abbreviation: "KS" },
		{ name: "Kentucky", abbreviation: "KY" },
		{ name: "Louisiana", abbreviation: "LA" },
		{ name: "Maine", abbreviation: "ME" },
		{ name: "Maryland", abbreviation: "MD" },
		{ name: "Massachusetts", abbreviation: "MA" },
		{ name: "Michigan", abbreviation: "MI" },
		{ name: "Minnesota", abbreviation: "MN" },
		{ name: "Mississippi", abbreviation: "MS" },
		{ name: "Missouri", abbreviation: "MO" },
		{ name: "Montana", abbreviation: "MT" },
		{ name: "Nebraska", abbreviation: "NE" },
		{ name: "Nevada", abbreviation: "NV" },
		{ name: "New Hampshire", abbreviation: "NH" },
		{ name: "New Jersey", abbreviation: "NJ" },
		{ name: "New Mexico", abbreviation: "NM" },
		{ name: "New York", abbreviation: "NY" },
		{ name: "North Carolina", abbreviation: "NC" },
		{ name: "North Dakota", abbreviation: "ND" },
		{ name: "Ohio", abbreviation: "OH" },
		{ name: "Oklahoma", abbreviation: "OK" },
		{ name: "Oregon", abbreviation: "OR" },
		{ name: "Pennsylvania", abbreviation: "PA" },
		{ name: "Rhode Island", abbreviation: "RI" },
		{ name: "South Carolina", abbreviation: "SC" },
		{ name: "South Dakota", abbreviation: "SD" },		
		{ name: "Tennessee", abbreviation: "TN" },
		{ name: "Texas", abbreviation: "TX" },
		{ name: "Utah", abbreviation: "UT" },
		{ name: "Vermont", abbreviation: "VT" },
		{ name: "Virginia", abbreviation: "VA" },
		{ name: "Washington", abbreviation: "WA" },
		{ name: "West Virginia", abbreviation: "WV" },
		{ name: "Wisconsin", abbreviation: "WI" },
		{ name: "Wyoming", abbreviation: "WY" },
		{ name: "American Samoa", abbreviation: "AS" },
		{ name: "District of Columbia", abbreviation: "DC" },
		{ name: "Federated States of Micronesia", abbreviation: "FM" },
		{ name: "Guam", abbreviation: "GU" },
		{ name: "Marshall Islands", abbreviation: "MH" },
		{ name: "Northern Mariana Islands", abbreviation: "MP" },
		{ name: "Palau", abbreviation: "PW" },
		{ name: "Puerto Rico", abbreviation: "PR" },
		{ name: "Virgin Islands", abbreviation: "VI" }
	],
	SECRET:"cQ2mM<PPrennUWWikincskk:L:PCJKWNcnmamewi64212019",
	zeacardColors: [ "blue-green", "light-blue", "light-green", "light-orange", "light-purple", "light-yellow", "purple-blue",'mri','ct','colonoscopy','cardio','pediatrics','psychatrics','Wellness','Mammography' ],
	//  Pie Chart data
	PieOptions : {
		chart: {
		  type: 'pie'
		},
		title: {
			text: 'Browser market shares. January, 2018'
		},
		subtitle: {
			text: 'Click the slices to view versions. Source: <a href="http://statcounter.com" target="_blank">statcounter.com</a>'
		},
	
		accessibility: {
			announceNewData: {
				enabled: true
			},
			point: {
				valueSuffix: '%'
			}
		},
	
		plotOptions: {
			series: {
				dataLabels: {
					enabled: true,
					format: '{point.name}: {point.y:.1f}%'
				}
			}
		},
	
		tooltip: {
			headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
			pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>'
		},
	
		series: [
			{
				name: "Browsers",
				colorByPoint: true,
				data: [
					{
						name: "Chrome",
						y: 62.74,
						drilldown: "Chrome"
					},
					{
						name: "Firefox",
						y: 10.57,
						drilldown: "Firefox"
					},
					{
						name: "Internet Explorer",
						y: 7.23,
						drilldown: "Internet Explorer"
					},
					{
						name: "Safari",
						y: 5.58,
						drilldown: "Safari"
					},
					{
						name: "Edge",
						y: 4.02,
						drilldown: "Edge"
					},
					{
						name: "Opera",
						y: 1.92,
						drilldown: "Opera"
					},
					{
						name: "Other",
						y: 7.62,
						drilldown: null
					}
				]
			}
		],
		drilldown: {
			series: [
				{
					name: "Chrome",
					id: "Chrome",
					data: [
						[
							"v65.0",
							0.1
						],
						[
							"v64.0",
							1.3
						],
						[
							"v63.0",
							53.02
						],
						[
							"v62.0",
							1.4
						],
						[
							"v61.0",
							0.88
						],
						[
							"v60.0",
							0.56
						],
						[
							"v59.0",
							0.45
						],
						[
							"v58.0",
							0.49
						],
						[
							"v57.0",
							0.32
						],
						[
							"v56.0",
							0.29
						],
						[
							"v55.0",
							0.79
						],
						[
							"v54.0",
							0.18
						],
						[
							"v51.0",
							0.13
						],
						[
							"v49.0",
							2.16
						],
						[
							"v48.0",
							0.13
						],
						[
							"v47.0",
							0.11
						],
						[
							"v43.0",
							0.17
						],
						[
							"v29.0",
							0.26
						]
					]
				},
				{
					name: "Firefox",
					id: "Firefox",
					data: [
						[
							"v58.0",
							1.02
						],
						[
							"v57.0",
							7.36
						],
						[
							"v56.0",
							0.35
						],
						[
							"v55.0",
							0.11
						],
						[
							"v54.0",
							0.1
						],
						[
							"v52.0",
							0.95
						],
						[
							"v51.0",
							0.15
						],
						[
							"v50.0",
							0.1
						],
						[
							"v48.0",
							0.31
						],
						[
							"v47.0",
							0.12
						]
					]
				},
				{
					name: "Internet Explorer",
					id: "Internet Explorer",
					data: [
						[
							"v11.0",
							6.2
						],
						[
							"v10.0",
							0.29
						],
						[
							"v9.0",
							0.27
						],
						[
							"v8.0",
							0.47
						]
					]
				},
				{
					name: "Safari",
					id: "Safari",
					data: [
						[
							"v11.0",
							3.39
						],
						[
							"v10.1",
							0.96
						],
						[
							"v10.0",
							0.36
						],
						[
							"v9.1",
							0.54
						],
						[
							"v9.0",
							0.13
						],
						[
							"v5.1",
							0.2
						]
					]
				},
				{
					name: "Edge",
					id: "Edge",
					data: [
						[
							"v16",
							2.6
						],
						[
							"v15",
							0.92
						],
						[
							"v14",
							0.4
						],
						[
							"v13",
							0.1
						]
					]
				},
				{
					name: "Opera",
					id: "Opera",
					data: [
						[
							"v50.0",
							0.96
						],
						[
							"v49.0",
							0.82
						],
						[
							"v12.1",
							0.14
						]
					]
				}
			]
		}
	},

	options: {
		chart: {
		  type: 'area'
		},
		accessibility: {
		  description: 'Image description: An area chart compares the nuclear stockpiles of the USA and the USSR/Russia between 1945 and 2017. The number of nuclear weapons is plotted on the Y-axis and the years on the X-axis. The chart is interactive, and the year-on-year stockpile levels can be traced for each country. The US has a stockpile of 6 nuclear weapons at the dawn of the nuclear age in 1945. This number has gradually increased to 369 by 1950 when the USSR enters the arms race with 6 weapons. At this point, the US starts to rapidly build its stockpile culminating in 32,040 warheads by 1966 compared to the USSR’s 7,089. From this peak in 1966, the US stockpile gradually decreases as the USSR’s stockpile expands. By 1978 the USSR has closed the nuclear gap at 25,393. The USSR stockpile continues to grow until it reaches a peak of 45,000 in 1986 compared to the US arsenal of 24,401. From 1986, the nuclear stockpiles of both countries start to fall. By 2000, the numbers have fallen to 10,577 and 21,000 for the US and Russia, respectively. The decreases continue until 2017 at which point the US holds 4,018 weapons compared to Russia’s 4,500.'
		},
		title: {
		  text: 'US and USSR nuclear stockpiles'
		},
		subtitle: {
		  text: 'Sources: <a href="https://thebulletin.org/2006/july/global-nuclear-stockpiles-1945-2006">' +
			'thebulletin.org</a> & <a href="https://www.armscontrol.org/factsheets/Nuclearweaponswhohaswhat">' +
			'armscontrol.org</a>'
		},
		xAxis: {
		  allowDecimals: false,
		  labels: {
			formatter: function () {
			  return this.value; // clean, unformatted number for year
			}
		  },
		  accessibility: {
			rangeDescription: 'Range: 1940 to 2017.'
		  }
		},
		yAxis: {
		  title: {
			text: 'Nuclear weapon states'
		  },
		  labels: {
			formatter: function () {
			  return this.value / 1000 + 'k';
			}
		  }
		},
		tooltip: {
		  pointFormat: '{series.name} had stockpiled <b>{point.y:,.0f}</b><br/>warheads in {point.x}'
		},
		plotOptions: {
		  area: {
			pointStart: 1940,
			marker: {
			  enabled: false,
			  symbol: 'circle',
			  radius: 2,
			  states: {
				hover: {
				  enabled: true
				}
			  }
			}
		  }
		},
		series: [{
		  name: 'USA',
		  data: [
			null, null, null, null, null, 6, 11, 32, 110, 235,
			369, 640, 1005, 1436, 2063, 3057, 4618, 6444, 9822, 15468,
			20434, 24126, 27387, 29459, 31056, 31982, 32040, 31233, 29224, 27342,
			26662, 26956, 27912, 28999, 28965, 27826, 25579, 25722, 24826, 24605,
			24304, 23464, 23708, 24099, 24357, 24237, 24401, 24344, 23586, 22380,
			21004, 17287, 14747, 13076, 12555, 12144, 11009, 10950, 10871, 10824,
			10577, 10527, 10475, 10421, 10358, 10295, 10104, 9914, 9620, 9326,
			5113, 5113, 4954, 4804, 4761, 4717, 4368, 4018
		  ]
		}, {
		  name: 'USSR/Russia',
		  data: [null, null, null, null, null, null, null, null, null, null,
			5, 25, 50, 120, 150, 200, 426, 660, 869, 1060,
			1605, 2471, 3322, 4238, 5221, 6129, 7089, 8339, 9399, 10538,
			11643, 13092, 14478, 15915, 17385, 19055, 21205, 23044, 25393, 27935,
			30062, 32049, 33952, 35804, 37431, 39197, 45000, 43000, 41000, 39000,
			37000, 35000, 33000, 31000, 29000, 27000, 25000, 24000, 23000, 22000,
			21000, 20000, 19000, 18000, 18000, 17000, 16000, 15537, 14162, 12787,
			12600, 11400, 5500, 4512, 4502, 4502, 4500, 4500
		  ]
		}]
	},
	lineOptions:{

		title: {
			text: 'Solar Employment Growth by Sector, 2010-2016'
		},
	
		subtitle: {
			text: 'Source: thesolarfoundation.com'
		},
	
		yAxis: {
			title: {
				text: 'Number of Employees'
			}
		},
	
		xAxis: {
			accessibility: {
				rangeDescription: 'Range: 2010 to 2017'
			}
		},
	
		legend: {
			layout: 'vertical',
			align: 'right',
			verticalAlign: 'middle'
		},
	
		plotOptions: {
			series: {
				label: {
					connectorAllowed: false
				},
				pointStart: 2010
			}
		},
	
		series: [{
			name: 'Installation',
			data: [43934, 52503, 57177, 69658, 97031, 119931, 137133, 154175]
		}, {
			name: 'Manufacturing',
			data: [24916, 24064, 29742, 29851, 32490, 30282, 38121, 40434]
		}, {
			name: 'Sales & Distribution',
			data: [11744, 17722, 16005, 19771, 20185, 24377, 32147, 39387]
		}, {
			name: 'Project Development',
			data: [null, null, 7988, 12169, 15112, 22452, 34400, 34227]
		}, {
			name: 'Other',
			data: [12908, 5948, 8105, 11248, 8989, 11816, 18274, 18111]
		}],
	
		responsive: {
			rules: [{
				condition: {
					maxWidth: 500
				},
				chartOptions: {
					legend: {
						layout: 'horizontal',
						align: 'center',
						verticalAlign: 'bottom'
					}
				}
			}]
		}
	
	},
	columnOptions:{
		chart: {
			type: 'column'
		},
		title: {
			text: 'Browser market shares. January, 2018'
		},
		subtitle: {
			text: 'Click the columns to view versions. Source: <a href="http://statcounter.com" target="_blank">statcounter.com</a>'
		},
		accessibility: {
			announceNewData: {
				enabled: true
			}
		},
		xAxis: {
			type: 'category'
		},
		yAxis: {
			title: {
				text: 'Total percent market share'
			}
	
		},
		legend: {
			enabled: false
		},
		plotOptions: {
			series: {
				borderWidth: 0,
				dataLabels: {
					enabled: true,
					format: '{point.y:.1f}%'
				}
			}
		},
	
		tooltip: {
			headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
			pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>'
		},
	
		series: [
			{
				name: "Browsers",
				colorByPoint: true,
				data: [
					{
						name: "Chrome",
						y: 62.74,
						drilldown: "Chrome"
					},
					{
						name: "Firefox",
						y: 10.57,
						drilldown: "Firefox"
					},
					{
						name: "Internet Explorer",
						y: 7.23,
						drilldown: "Internet Explorer"
					},
					{
						name: "Safari",
						y: 5.58,
						drilldown: "Safari"
					},
					{
						name: "Edge",
						y: 4.02,
						drilldown: "Edge"
					},
					{
						name: "Opera",
						y: 1.92,
						drilldown: "Opera"
					},
					{
						name: "Other",
						y: 7.62,
						drilldown: null
					}
				]
			}
		],
		drilldown: {
			series: [
				{
					name: "Chrome",
					id: "Chrome",
					data: [
						[
							"v65.0",
							0.1
						],
						[
							"v64.0",
							1.3
						],
						[
							"v63.0",
							53.02
						],
						[
							"v62.0",
							1.4
						],
						[
							"v61.0",
							0.88
						],
						[
							"v60.0",
							0.56
						],
						[
							"v59.0",
							0.45
						],
						[
							"v58.0",
							0.49
						],
						[
							"v57.0",
							0.32
						],
						[
							"v56.0",
							0.29
						],
						[
							"v55.0",
							0.79
						],
						[
							"v54.0",
							0.18
						],
						[
							"v51.0",
							0.13
						],
						[
							"v49.0",
							2.16
						],
						[
							"v48.0",
							0.13
						],
						[
							"v47.0",
							0.11
						],
						[
							"v43.0",
							0.17
						],
						[
							"v29.0",
							0.26
						]
					]
				},
				{
					name: "Firefox",
					id: "Firefox",
					data: [
						[
							"v58.0",
							1.02
						],
						[
							"v57.0",
							7.36
						],
						[
							"v56.0",
							0.35
						],
						[
							"v55.0",
							0.11
						],
						[
							"v54.0",
							0.1
						],
						[
							"v52.0",
							0.95
						],
						[
							"v51.0",
							0.15
						],
						[
							"v50.0",
							0.1
						],
						[
							"v48.0",
							0.31
						],
						[
							"v47.0",
							0.12
						]
					]
				},
				{
					name: "Internet Explorer",
					id: "Internet Explorer",
					data: [
						[
							"v11.0",
							6.2
						],
						[
							"v10.0",
							0.29
						],
						[
							"v9.0",
							0.27
						],
						[
							"v8.0",
							0.47
						]
					]
				},
				{
					name: "Safari",
					id: "Safari",
					data: [
						[
							"v11.0",
							3.39
						],
						[
							"v10.1",
							0.96
						],
						[
							"v10.0",
							0.36
						],
						[
							"v9.1",
							0.54
						],
						[
							"v9.0",
							0.13
						],
						[
							"v5.1",
							0.2
						]
					]
				},
				{
					name: "Edge",
					id: "Edge",
					data: [
						[
							"v16",
							2.6
						],
						[
							"v15",
							0.92
						],
						[
							"v14",
							0.4
						],
						[
							"v13",
							0.1
						]
					]
				},
				{
					name: "Opera",
					id: "Opera",
					data: [
						[
							"v50.0",
							0.96
						],
						[
							"v49.0",
							0.82
						],
						[
							"v12.1",
							0.14
						]
					]
				}
			]
		}
	}

};
